<template>
  <div class="header">
    <div class="container-fluid">
      <!-- Hearer  -->
      <div class="mt-4">
        <div class="card">
          <div class="card-body">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item fw-bolder">Master Data</li>
                <li class="breadcrumb-item">Organizations</li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Card  -->
      <div class="card mt-5">
        <form ref="myFormSave" @submit.prevent="saveAdd()">
        <div class="card-header">
          <!-- Title -->
          <h4 class="card-header-title">Form Input Organizations</h4>
          <b-button v-b-modal.modal-1 variant="primary" class="ml-1" @click="confirmAndCloseModal">
            Cancel
          </b-button>
          <b-button type="submit" variant="primary" class="ml-1">
            Save
          </b-button>
        </div>
        <div class="card-body">
          <div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Code</label>
                  <input name="code" type="text" required class="form-control" v-model="payload.code" aria-required="true" />
                </div>
                <div class="form-group">
                  <label>Name</label>
                  <input name="name" type="text" required class="form-control" v-model="payload.name" aria-required="true" />
                </div>
                <div class="form-group">
                  <label>Company</label>
                  <input name="name" type="text" required class="form-control" value="7003" disabled />

                </div>

              </div>
            </div>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from "@/components/ToggleSwitch.vue";
import index from "vuex";
import axiosIns from "@/api/axios";

export default {
  name: "ListUser",
  components: {ToggleSwitch},
  computed: {
    detail() {
      //return this.$store.getters["user/detail"];
    },
  },
  data() {
    return {
      payload: {
        code: null,
        name: "",
        is_divisi: false,
        company_code: 7003,
        parent_id: null,
      },
      id: "",
      isAdd: true,
      isLoading: false,
      listCompany: [],
      listDepartement: [],
      selectedRole: null,
      paramName: null,
      paramEmail: null,
      paramRole: null,
      isDivisi: false
    };
  },

  mounted() {
    this.getListCompany();
    this.getListDepartment();
    this.role_id = localStorage.getItem('roles')
  },
  methods: {
    async getListCompany() {
      try {
        const response = await axiosIns.get("/master-org-chart/company-list");
        console.log("response: ", response.data.data);
        this.listCompany = response.data.data.map(items => ({
          label: items.company_name,
          value: items.company_code
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    async getListDepartment() {
      try {
        const response = await axiosIns.get("/master-org-chart/divisi");
        this.listDepartement = response.data.data.map(items => ({
          label: items.name,
          value: items.id
        }));
      } catch (error) {
        console.error("Failed to fetch year options:", error);
      }

    },
    btnBack() {
      this.$router.push(`/master-data/user`)
    },
    btnCancel() {
      this.payload = {
        code: "",
        name: "",
        is_divisi: false,
        company_code: "",
        parent_id: "",
      };
    },
    saveAdd() {
      try {
        this.isLoading = true;
        //this.payload.parent_id = !this.payload.is_divisi ? this.payload.parent_id : null;
        this.$store
            .dispatch("masterOrgChart/CREATE_DATA", this.payload)
            .then((resp) => {
              this.$swal("Saved", "Your input has been saved", "success").then(
                  (resp) => {
                    this.isLoading = false;
                    this.$bvModal.hide("modal-1");
                    this.$router.push(`/master-data/org-chart`)
                  }
              );
            });
      } catch (error) {
        this.$swal("Error", "Error while add data", "error");
      }
    },
    confirmAndCloseModal() {
      this.$swal({
        title: 'Confirm Close?',
        text: 'Are you sure you want to close this page?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#00D97E',
        cancelButtonColor: '#E63757',
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
      }).then((result) => {
        if (result.isConfirmed) {
          this.$bvModal.hide('modal-1');
          this.$router.push(`/master-data/org-chart`)
        }
      });
    },
  },
};
</script>
